<template>
  <div style="padding:10px;width:300px;">

    <Field :type="1" addbtn placeholder="开课城市"></Field>

    <Alert type="info">提示：自2025-04-18日起，开课城市会自动和crm系统中招生中的城市进行同步，同步时间为每天00:05。若在自动同步之前需要新增/删除开课城市，可在此板块操作。</Alert>
  </div>
</template>
<script>
import Field from "./common/field/Field.vue";
export default {
  components:{Field}

}
</script>



// WEBPACK FOOTER //
// src/components/City.vue